
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPageFlow from './LandingPageFlow';
import LandingSmsFlow from './LandingSmsFlow';

function App() 
{
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPageFlow />} />
        <Route path="/sms" element={<LandingSmsFlow />} />
      </Routes>
    </Router>
  );
}

export default App;